import {useCallback} from 'react';

import {useCommonDataHook} from 'src/hooks/use-common-data-hook';
import {getAccountLimits, saveAccountLimits} from 'src/openapi/admin/apis/AccountLimitsApi';
import {useAppDispatch} from 'src/store/hooks';

import {DEFAULT_ACCOUNT_LIMITS} from './constants';

import type {AccountLimits} from 'src/openapi/admin/models/AccountLimits';

type Props = {
    accountId: number,
};

export const useAccountLimits = ({accountId}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback((signal: AbortSignal) => apiDispatch(
        getAccountLimits({accountId}, {signal}),
    ), [accountId, apiDispatch]);

    const saveDispatchAction = useCallback((accountLimits: AccountLimits, signal: AbortSignal) => apiDispatch(
        saveAccountLimits({accountId, accountLimits}, {signal}),
    ), [accountId, apiDispatch]);

    return useCommonDataHook({
        initValue: DEFAULT_ACCOUNT_LIMITS,
        getDispatchAction,
        saveDispatchAction,
    });
};
